import React, { Component } from "react";
import Desktop from "../../../Desktop";
import Items from "../../Items";

class ItemsParent extends Component {
  render() {
    return (
      <React.Fragment>
        {window.innerWidth >= 768 ? (
          <Desktop merchant={this.props.match.params.merchant} />
        ) : (
          <Items
            merchant={this.props.match.params.merchant}
            history={this.props.history}
          />
        )}
      </React.Fragment>
    );
  }
}

export default ItemsParent;
